export const getFailureCauseCategoriesStatusTabItems = (t: (text: string) => void) => [
  { value: 'all', label: t('All') },
  { value: 'active', label: t('Active') },
  { value: 'archived', label: t('archived') },
];
